<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar></medsurf-navbar>
  <!-- Toolbar -->
  <medsurf-toolbar class="mb-2"
  [showNodeTreeButton]="true"></medsurf-toolbar>
  <!-- Content -->
  @if ({
    node: slideAuthorFacade.currentSelectedNode$ | async
  }; as currentSelectedNode) {
    @if ({
      editPanelData: slideAuthorFacade.editPanelData$ | async,
      editPanelOverlay: slideAuthorFacade.editPanelOverlay$ | async
    }; as editData) {
      <p-splitter
        [blockUi]="[
          {blocked: (appSharedFacade.canWriteNode$(currentSelectedNode.node?.id) | async) === false}
        ]"
        class="flex flex-1 overflow-hidden justify-content-center h-full mb-2"
        styleClass="w-full"
        panelStyleClass="min-w-4_5rem"
        [gutterSize]="FlatModels.PanelDesignModels.panelGutterSizeBig"
        [panelSizes]="editData.editPanelData?.panelSize || FlatModels.PanelDesignModels.editPanelSize"
        [minSizes]="[FlatModels.PanelDesignModels.panelMinSizeMain, FlatModels.PanelDesignModels.panelMinSizeSmall]"
        layout="horizontal"
        (onResizeStart)="editOnResizeStart()"
        (onResizeEnd)="editOnResizeEnd($event)">
        <ng-template pTemplate>
          <medsurf-slide-main class="surface-600 medsurf-white"></medsurf-slide-main>
        </ng-template>
        <ng-template pTemplate>
          <medsurf-design-content-collapsible-panel id="slide_tree_panel"
            class="w-full slide_edited_by"
            [isMinimized]="editData.editPanelData?.isMinimized || false"
            titleText="global.edit"
            menuName="slide_menu"
            [menuItems]="(editMenuItems$ | async) || []"
            (collapsedChange)="editCollapsedChange($event)">
            <ng-container ngProjectAs="panel-header-extra">
              <!-- Edited By -->
              @if (nodeSharedFacade.currentSelectedPage$ | async; as page) {
                @if ({
                  at: page?.editedAt,
                  user: (appSharedFacade.user$(page.editedBy) | async)
                }; as edited) {
                  @if (edited.at) {
                    @if ({
                      edited: (edited.at | date_shared) + (edited.user ? ' (' + (edited.user.firstName && edited.user.lastName ? edited.user.firstName + ' ' + edited.user.lastName : edited.user.email) + ')' : '')
                    }; as output) {
                      <div 
                        class="text-sm edited-by font-normal overflow-hidden align-self-center text-right h-1rem" 
                        [title]="('global.last_changed' | translate) + ': ' + (output.edited)"
                      >
                        <span class="fa fa-clock-rotate-left"></span>
                        <span class="white-space-nowrap"> {{ output.edited }}</span>
                      </div>
                    }
                  }
                }
              }
            </ng-container>

            <!-- Copy Tools -->
            @if ({
              copyType: bulkEditAuthorFacade.copyType$ | async,
              slideBulkEditItemCount: (bulkEditAuthorFacade.slideBulkEditItemCount$ | async) || 0,
              slideBulkCopyItemCount: (bulkEditAuthorFacade.slideBulkCopyItemCount$ | async) || 0,
              copyAnnotationSet: (bulkEditAuthorFacade.copyAnnotationSet$ | async)
            }; as selectionData) {
              <div
                class="flex flex-row column-gap-2 h-3rem"
                [class.medsurf-copy]="editData.editPanelOverlay === false"
                [class.p-panel-header]="selectionData.slideBulkEditItemCount > 0 || selectionData.slideBulkCopyItemCount > 0">
                @if (selectionData.slideBulkEditItemCount === 0 && selectionData.slideBulkCopyItemCount > 0) {
                  @if (selectionData.copyType && selectionData.copyAnnotationSet?.size === 0) {
                    <button medsurf-design-input-button
                      id="slide_paste_nodes"
                      [label]="FlatModels.BulkEditAuthorModels.BulkEditEntityTypeCopyDescription[selectionData.copyType] + (selectionData.slideBulkCopyItemCount === 1 ? '_singular' : '_plural') | translate: {count: selectionData.slideBulkCopyItemCount}"
                      [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                      [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PASTE_MR_2"
                    (click)="pasteSelection()"></button>
                  }
                  @if (selectionData.copyAnnotationSet?.size !== 0) {
                    <medsurf-design-input-menu
                      [formField]="false"
                      name="slide_paste_menu"
                      [label]="(selectionData.slideBulkCopyItemCount === 1 ? 'global.annotations_paste_singular' : 'global.annotations_paste_plural') | translate: {count: selectionData.slideBulkCopyItemCount}"
                      [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                      [buttonIconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PASTE_MR_2"
                    [loadMenuItems]="getSlidePasteMenuItems"></medsurf-design-input-menu>
                  }
                }
                @if (selectionData.slideBulkEditItemCount > 0) {
                  <button medsurf-design-input-button id="selection_desc"
                    [label]="'global.selection_desc' | translate: {count: selectionData.slideBulkEditItemCount}"
                    [disabled]="selectionData.slideBulkEditItemCount === 0"
                    [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL"
                    [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.TIMES_MR_2"
                  (click)="deselectSelection()"></button>
                  <div medsurf-design-content-input-group>
                    <button medsurf-design-input-button id="selection_copy"
                      [title]="'global.selection_copy' | translate"
                      [disabled]="selectionData.slideBulkEditItemCount === 0"
                      [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                      [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.COPY"
                    (click)="selectionData.slideBulkEditItemCount > 0 && copySelection()"></button>
                    @if (selectionData.copyAnnotationSet?.size === 0) {
                      <button medsurf-design-input-button
                        id="selection_paste"
                        [title]="'global.selection_paste' | translate"
                        [disabled]="selectionData.slideBulkCopyItemCount === 0"
                        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PASTE"
                      (click)="selectionData.slideBulkCopyItemCount > 0 && pasteSelection()"></button>
                    }
                    @if (selectionData.copyAnnotationSet?.size !== 0) {
                      <medsurf-design-input-menu
                        [formField]="false"
                        name="slide_paste_menu"
                        [tooltipLabel]="'global.selection_paste' | translate"
                        [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                        [buttonIconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PASTE"
                      [loadMenuItems]="getSlidePasteMenuItems"></medsurf-design-input-menu>
                    }
                    <button medsurf-design-input-button id="slide_remove_nodes"
                      [title]="'global.selection_remove' | translate"
                      [disabled]="selectionData.slideBulkEditItemCount === 0"
                      [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                      [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
                    (click)="selectionData.slideBulkEditItemCount > 0 && removeSelection()"></button>
                  </div>
                }
              </div>
            }
            @if ({
              editPanelDisplay: slideAuthorFacade.editPanelDisplay$ | async,
              editPanelBulkEdit: slideAuthorFacade.editPanelBulkEdit$ | async
            }; as editPanelData) {
              <div class="flex flex-1 overflow-hidden justify-content-center h-full max-h-sidebar">
                @if (editData.editPanelOverlay === true) {
                  @if (editPanelData.editPanelBulkEdit || editPanelData.editPanelDisplay === FlatModels.SlideAuthorModels.EditPanelDisplay.enum.list) {
                    <div #slide_tree_scroll_panel
                         class="flex flex-1 overflow-auto mb-7"
                         [@listSlide]>
                      <medsurf-common-slide-tree class="flex flex-1"></medsurf-common-slide-tree>
                    </div>
                  }
                  @if (!editPanelData.editPanelBulkEdit) {
                    @switch (editPanelData.editPanelDisplay) {
                      @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.layer) {
                        @if (slideAuthorFacade.currentSelectedSlideLayer$ | async; as layer) {
                          <div class="flex flex-1 overflow-auto mb-7">
                            <medsurf-slide-edit class="flex flex-1 animation-duration-100"
                                                [@editSlide]></medsurf-slide-edit>
                          </div>
                        }
                        @else {
                          <div #slide_tree_scroll_panel
                               class="flex flex-1 overflow-auto mb-7"
                               [@listSlide]>
                            <medsurf-common-slide-tree class="flex flex-1"></medsurf-common-slide-tree>
                          </div>
                        }
                      }
                      @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.question) {
                        @if (slideAuthorFacade.currentSelectedSlideQuestion$ | async; as question) {
                          <div class="flex flex-1 overflow-auto mb-7">
                            <medsurf-slide-edit class="flex flex-1 animation-duration-100"
                                                [@editSlide]></medsurf-slide-edit>
                          </div>
                        }
                        @else {
                          <div #slide_tree_scroll_panel
                               class="flex flex-1 overflow-auto mb-7"
                               [@listSlide]>
                            <medsurf-common-slide-tree class="flex flex-1"></medsurf-common-slide-tree>
                          </div>
                        }
                      }
                      @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.group) {
                        @if (this.slideAuthorFacade.currentSelectedSlideGroup$ | async; as group) {
                          <div class="flex flex-1 overflow-auto mb-7">
                            <medsurf-slide-edit class="flex flex-1 animation-duration-100"
                                                [@editSlide]></medsurf-slide-edit>
                          </div>
                        }
                        @else {
                          <div #slide_tree_scroll_panel
                               class="flex flex-1 overflow-auto mb-7"
                               [@listSlide]>
                            <medsurf-common-slide-tree class="flex flex-1"></medsurf-common-slide-tree>
                          </div>
                        }
                      }
                      @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.poi) {
                        @if (this.slideAuthorFacade.currentSelectedSlidePoi$ | async; as poi) {
                          <div class="flex flex-1 overflow-auto mb-7">
                            <medsurf-slide-edit class="flex flex-1 animation-duration-100"
                                                [@editSlide]></medsurf-slide-edit>
                          </div>
                        }
                        @else {
                          <div #slide_tree_scroll_panel
                               class="flex flex-1 overflow-auto mb-7"
                               [@listSlide]>
                            <medsurf-common-slide-tree class="flex flex-1"></medsurf-common-slide-tree>
                          </div>
                        }
                      }
                      @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.image) {
                        @if (slideAuthorFacade.currentSelectedSlideImage$ | async; as image) {
                          <div class="flex flex-1 overflow-auto mb-7">
                            <medsurf-slide-edit class="flex flex-1 animation-duration-100"
                                                [@editSlide]></medsurf-slide-edit>
                          </div>
                        }
                        @else {
                          <div #slide_tree_scroll_panel
                               class="flex flex-1 overflow-auto mb-7"
                               [@listSlide]>
                            <medsurf-common-slide-tree class="flex flex-1"></medsurf-common-slide-tree>
                          </div>
                        }
                      }
                      @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.annotation) {
                        @if (slideAuthorFacade.currentSelectedSlideAnnotation$ | async; as annotation) {
                          <div class="flex flex-1 overflow-auto mb-7">
                            <medsurf-slide-edit class="flex flex-1 animation-duration-100"
                                                [@editSlide]></medsurf-slide-edit>
                          </div>
                        }
                        @else {
                          <div #slide_tree_scroll_panel
                               class="flex flex-1 overflow-auto mb-7"
                               [@listSlide]>
                            <medsurf-common-slide-tree class="flex flex-1"></medsurf-common-slide-tree>
                          </div>
                        }
                      }
                      @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.metadata) {
                        @if (slideAuthorFacade.currentSelectedSlide$ | async; as slide) {
                          <div class="flex flex-1 overflow-auto mb-7">
                            <medsurf-slide-edit class="flex flex-1 animation-duration-100"
                                                [@editSlide]></medsurf-slide-edit>
                          </div>
                        }
                        @else {
                          <div #slide_tree_scroll_panel
                               class="flex flex-1 overflow-auto mb-7"
                               [@listSlide]>
                            <medsurf-common-slide-tree class="flex flex-1"></medsurf-common-slide-tree>
                          </div>
                        }
                      }
                    }
                  }
                }
                @if (editData.editPanelOverlay === false) {
                  <div
                    class="flex flex-1">
                    @if (slideAuthorFacade.layerPanelData$ | async; as layerPanelData) {
                      <p-splitter
                        [hidden]="layerPanelData.isMinimized"
                        class="flex flex-1 h-full overflow-hidden justify-content-center"
                        styleClass="w-full edit-splitter-panel"
                        [gutterSize]="FlatModels.PanelDesignModels.panelGutterSize"
                        [panelSizes]="layerPanelData.panelSize"
                        [minSizes]="[FlatModels.PanelDesignModels.panelMinSizeVertical, FlatModels.PanelDesignModels.panelMinSizeVertical]"
                        layout="horizontal"
                        (onResizeStart)="layerOnResizeStart()"
                        (onResizeEnd)="layerOnResizeEnd($event)">
                        <ng-template pTemplate>
                          <div #slide_tree_scroll_panel
                               class="flex flex-1 overflow-auto mb-7">
                            <medsurf-common-slide-tree class="flex flex-1"></medsurf-common-slide-tree>
                          </div>
                        </ng-template>
                        <ng-template pTemplate>
                          <div class="flex flex-1 overflow-auto mb-7">
                            <medsurf-slide-edit class="flex flex-1"></medsurf-slide-edit>
                          </div>
                        </ng-template>
                      </p-splitter>
                    }
                  </div>
                }
              </div>
            }
          </medsurf-design-content-collapsible-panel>
        </ng-template>
      </p-splitter>
    }
  }
</div>
